export const selectors = {
	primaryCtr: '.theater',
	stage: '.theater__stage',
	content: '.theater__content',
	nav: '.theater__entry',
	video: 'video',
	animation: 'div',
	image: 'img',
};

export const classNames = {
	desktop: 'theater--desktop',
	mobile: 'theater--mobile',
	activeContent: 'theater__content--active',
	activeNav: 'theater__entry--active',
	navPause: 'theater__entry--pause',
	bottomNav: 'theater--bottom',
};

export const breakpoint = 1400;
